import { render } from "./ActionButtons.vue?vue&type=template&id=42895e5a&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&lang=ts"

import "./ActionButtons.vue?vue&type=style&index=0&id=42895e5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42895e5a"

export default script